import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GenericService } from './generic.service';
import { MESSAGECONSTANTS } from '../utils/constants';

export interface ParsedAddress {
  city?: string;
  state?: string;
  county?: string;
  country?: string;
  countryCode?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {
  constructor(private genericService: GenericService) { }

  getByZipCode(zipCode): Observable<any> {
    const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(zipCode) +
      '&key=' + MESSAGECONSTANTS.GEOCODING.API_KEY;
    return this.genericService.getObjects(url).pipe(map(response => response.body));
  }

  /**
   * `country` is the long name and `countryCode` the short one. When a postal code has no
   * locality, state/country/city are inferred from the broader administrative areas.
   */
  parseAddress(addressDetails, postalName?): ParsedAddress {
    const address: ParsedAddress = {};
    const components = addressDetails.address_components;
    const cityName = (component) => postalName ? postalName : component.long_name;
    const setCountry = (component) => {
      address.country = component.long_name;
      address.countryCode = component.short_name;
    };

    components.forEach((component) => {
      component.types.forEach((type) => {
        switch (type) {
          case 'country':
            setCountry(component);
            break;
          case 'administrative_area_level_2':
            address.county = component.long_name;
            break;
          case 'administrative_area_level_1':
            address.state = component.long_name;
            break;
          case 'locality':
            address.city = cityName(component);
            break;
        }
      });
    });

    if (address.city === undefined || address.state === undefined || address.country === undefined) {
      components.forEach((component) => {
        component.types.forEach((type) => {
          switch (type) {
            case 'locality':
              if (address.state === undefined) {
                address.state = component.long_name;
              }
              if (address.country === undefined) {
                setCountry(component);
              }
              break;
            case 'administrative_area_level_2':
              if (address.city === undefined) {
                address.city = cityName(component);
              }
              if (address.state === undefined) {
                address.state = component.long_name;
              }
              if (address.country === undefined) {
                setCountry(component);
              }
              break;
            case 'administrative_area_level_3':
            case 'administrative_area_level_4':
              if (address.city === undefined) {
                address.city = cityName(component);
              }
              break;
            case 'sublocality':
              address.city = cityName(component);
              break;
            case 'administrative_area_level_1':
              if (address.city === undefined) {
                address.city = cityName(component);
                if (address.country === undefined) {
                  setCountry(component);
                }
              }
              break;
          }
        });
      });
    }
    return address;
  }
}
